(()=>{
  const shell=document.querySelector('[data-it-ring-shell]');
  if(!shell)return;

  const shellSection=shell.closest('.shopify-section');
  const builderRoot=shellSection?.nextElementSibling;
  const norm=v=>(v||'').replace(/\s+/g,' ').trim().toLowerCase();
  const context=()=>{
    const p=new URLSearchParams(location.search);
    return {stage:p.get('stage')||'',detail:p.get('viewDetailsId')||''};
  };
  const key=()=>{
    const c=context(),s=norm(c.stage);
    if(s.includes('complete')||s.includes('review')||s.includes('ring size'))return 'review';
    if(s.includes('setting'))return 'setting';
    if(c.detail)return 'detail';
    if(s.includes('diamond'))return 'diamond';
    return 'start';
  };

  const content={
    diamond:{
      kicker:'Start with the diamond',title:'Choose your centre diamond',
      copy:'Begin with shape, then use the price and carat controls to set a comfortable range. The live results below update as you refine the search; once you select a diamond, you can continue to compatible ring settings.',
      steps:['Choose a shape','Set budget & carat','Compare live diamonds','Select a diamond'],
      tip:'Shape buttons narrow the live stones immediately. Drag either end of the price or carat slider to set a minimum and maximum — you do not need to hit one exact value.'
    },
    setting:{
      kicker:'Start with the design',title:'Choose your ring setting',
      copy:'Choose the ring design first, then refine the available metal and centre-stone options. Your chosen setting stays connected as you continue to a compatible diamond.',
      steps:['Choose a ring style','Choose the metal','Check centre shape','Continue to diamonds'],
      tip:'Use the style and shape options to narrow the design. When you continue, the builder keeps compatibility connected so you can compare diamonds suited to the selected setting.'
    },
    detail:{
      kicker:'Review this diamond',title:'Check the diamond before selecting it',
      copy:'Review the stone media and grading information supplied for this individual diamond before you continue. Keep the full detail available rather than judging on price or carat alone.',
      steps:['Review media','Check the 4Cs','Check measurements','Review report details'],
      tip:'Use the 360° media or video where supplied, then compare measurements, proportions and the grading report before selecting the stone.'
    },
    review:{
      kicker:'Complete your ring',title:'Review the complete design before checkout',
      copy:'Confirm the selected diamond, setting, metal, available ring size and total price. Imperial Time specialist support remains available if you want a second opinion before ordering.',
      steps:['Check diamond','Check setting & metal','Choose ring size','Review total & order'],
      tip:'Only choose a ring size shown as available for the selected design. If you are unsure, use Ring Size Help or arrange a Kensington fitting before ordering.'
    },
    start:{
      kicker:'Design your engagement ring',title:'Choose how you would like to begin',
      copy:'Start with the diamond if the centre stone matters most, or start with the design if you already know the ring style you prefer.',
      steps:['Choose a starting route','Refine your choice','Keep compatibility linked','Complete the ring'],
      tip:'Both routes lead to a complete diamond-and-setting combination; choose the part you feel most confident about first.'
    }
  };

  let last='';
  const update=()=>{
    const k=key();
    if(k===last)return;
    last=k;
    const c=content[k]||content.start;
    const set=(sel,val)=>{const el=shell.querySelector(sel);if(el)el.textContent=val;};
    set('[data-it-stage-kicker]',c.kicker);
    set('[data-it-stage-title]',c.title);
    set('[data-it-stage-copy]',c.copy);
    set('[data-it-stage-tip]',c.tip);
    c.steps.forEach((step,i)=>set(`[data-it-stage-step="${i}"]`,step));
    const guide=shell.querySelector('[data-it-stage-guide]');
    if(guide)guide.dataset.itStage=k;
  };

  update();
  let queued=false;
  if(builderRoot){
    new MutationObserver(()=>{
      if(queued)return;
      queued=true;
      requestAnimationFrame(()=>{queued=false;update();});
    }).observe(builderRoot,{subtree:true,childList:true});
  }
  window.addEventListener('popstate',()=>{last='';update();});
})();